<!-- Form.svelte -->
<script>
  /*
  // To Do:
  // - make clear that without logging in the script has less functionality.
  // - Consider filling formData also when not logged in. 
  */
  import { fade } from "svelte/transition";
  import { useFocus } from "svelte-navigator";
  import { navigate } from "svelte-navigator";
  import { birthData } from "../stores/birthData.js";
  import { formData } from "../stores/formData.js";
  import { user } from "../stores/user.js";
  import { showResultSection } from "../stores/showResultSection.js";
  import List from "./UserList.svelte";

  // Declare variables used for form fields first so they can be used for testing also.
  let name = "";
  let date = "";
  let time = "";
  let location = "";
  let dataIsSet = false;
  let isInitiated = false;
  let id;
  let token;

  showResultSection.set(false); // must be false always at start.
  /*
  // formData is only set after loging in or saving data. Why?
  // Can we fill it after the second submit in the form?
  let formDataArray;
  // React to store changes
  $: {
    formDataArray = Object.entries($formData);
    console.log(formDataArray);
  }
*/
  $: {
    // may only run once or else we can't update the fields
    if ($formData.isSet && !$formData.isInitiated) {
      dataIsSet = $formData.isSet;
      name = $formData.name;
      date = $formData.date;
      time = $formData.time;
      location = $formData.location;
      $formData = { ...$formData, isInitiated: true };
      isInitiated = $formData.isInitiated;
    }
  }
  /* 
  // first variables are for testing. They will be removed later
  date = "1963-07-19";
  time = "16:51:21";
  location = "Langstraat, ZH, Netherlands";
  name = "John Doe";
  // end of testing variables
  */

  const nameInput = useFocus();
  // declaring variables
  let latitude = "";
  let longitude = "";
  let tzName = "";
  let tzOffset = "";
  let formatted_address = "";
  /*
  let hours = 15;
  let minutes = 30;
  let seconds = 0;
  */
  let utcDateStr = "";
  let utcTime = "";
  let utcDate = "";
  let localTime = "";
  let utcFormatted = "";
  const uri = "https://astro.astrosofica.nl";
  let forceGMT = false;
  let forceLMT = false;
  let disableGMT = false;
  let disableLMT = false;
  let errorMessage = "";
  let showList = false;

  const openList = () => {
    showList = true;
  };

  const closeList = () => {
    showList = false;
  };

  async function handleSubmit(event) {
    event.preventDefault();
    // Clear errorMessage
    errorMessage = "";
    // Check fields
    if (!name || !date || !time || !location) {
      errorMessage = "Je moet alle velden invullen.";
      return;
    }
    // If seconds not provided, default to 00
    let timeSplit = time.split(":");
    if (timeSplit.length < 3) {
      time += ":00";
    }
    // Validate date and time
    const dateTime = new Date(`${date}T${time}`);
    if (isNaN(dateTime.getTime())) {
      errorMessage = "Vul een geldige datum en tijd in!";
      return;
    }
    forceGMT = false;
    forceLMT = false;
    // Prepare location data as JSON payload
    const locationData = { address: location };

    // Send POST request to custom backend for location details
    const geocodeUrl = uri + "/php/geocode.php";
    const geocodeResponse = await fetch(geocodeUrl, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(locationData),
    });
    const data = await geocodeResponse.json();

    // Extract location details
    const { status, lat, long, form_address } = data;
    if (status === "OK") {
      latitude = lat;
      longitude = long;
      formatted_address = form_address;
    } else {
      // handle error case
      console.error("Fout bij het ophalen van plaatscoördinaten:", status);
      errorMessage =
        "Fout bij het ophalen van plaatscoördinaten. Wees specifiek, bijvoorbeeld: 'Goes, Zeeland', 'Amsterdam, Nederland' of 'New York, USA'";
      return;
    }

    // Query API for timezone details
    const timestamp = Math.floor(dateTime.getTime() / 1000);
    const tzData = { lat: lat, long: long, timestamp: timestamp };
    const timezoneUrl = uri + "/php/timezone-g.php"; // was timezone.php
    const timezoneResponse = await fetch(timezoneUrl, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(tzData),
    });
    const timezoneData = await timezoneResponse.json();
    //const { timeZoneName, rawOffset, timeZoneId, debug } = timezoneData;
    const { timeZoneName, rawOffset, dstOffset, debug } = timezoneData;
    tzName = timeZoneName;
    tzOffset = rawOffset;
    tzOffset = tzOffset + dstOffset; // correctie ZT
    console.log (time, tzOffset, dstOffset); // wat gaat fout bij de tijdzone?
    makeUTC(date, time, tzOffset);
    // if formatted_address starts with 4 numbers, then it is a zip code. We need to remove the zip code from the location
    if (formatted_address.match(/^\d{4}(?!\d)/)) {
      location = formatted_address.replace(/^\d{4}\s*/, "");
    } else {
      location = formatted_address;
      //showResultSection = true;
      showResultSection.set(true);
    }
  }

  function toHour(seconds) {
    // make time ofset readable
    let hours = seconds / 3600;
    if (Math.floor(hours) * 3600 === seconds) {
      return hours;
    } else {
      // if offset is not a whole hour or has minutes and even seconds.

      let minutes = Math.floor((hours - Math.floor(hours)) * 60);
      let seconds = Math.round(
        (hours - Math.floor(hours) - minutes / 60) * 3600
      );
      return `${Math.floor(hours)}:${minutes}:${seconds}`;
    }
  }

  // Add leading zero to single digit numbers
  function padding(number) {
    return number.toString().padStart(2, "0");
  }

  function decimalToDMS(decimal) {
    const degrees = Math.floor(decimal);
    const minutes = Math.floor((decimal - degrees) * 60);
    const seconds = Math.round((decimal - degrees - minutes / 60) * 3600);
    const paddedDegrees = degrees.toString().padStart(3, "0");
    const paddedMinutes = minutes.toString().padStart(2, "0");
    const paddedSeconds = seconds.toString().padStart(2, "0");
    return `${paddedDegrees}°${paddedMinutes}'${paddedSeconds}"`;
  }

  function readableLatitude() {
    const hemisphere = latitude >= 0 ? "N" : "S";
    return `${decimalToDMS(Math.abs(latitude))}${hemisphere}`;
  }

  function readableLongitude() {
    const hemisphere = longitude >= 0 ? "E" : "W";
    return `${decimalToDMS(Math.abs(longitude))}${hemisphere}`;
  }

  function makeUTC(date, time, tzOffset) {
    const localTime = new Date(`${date}T${time}`).getTime();
    const localOffset = tzOffset * 1000;
    const utc = localTime - localOffset;
    const utcDate = new Date(utc);

    // prepare some variables: utcDay, utcMonth, utcYear, utcHours, utcMinutes, utcSeconds
    let utcDay = utcDate.getDate();
    let utcMonth = utcDate.getMonth() + 1;
    let utcYear = utcDate.getFullYear();
    let utcHours = utcDate.getHours();
    let utcMinutes = utcDate.getMinutes();
    let utcSeconds = utcDate.getSeconds();
    utcTime = `${padding(utcHours)}:${padding(utcMinutes)}:${padding(
      utcSeconds
    )}`;
    utcDateStr = `${padding(utcDay)}.${padding(utcMonth)}.${utcYear}`;
    utcFormatted = `${padding(utcDay)}-${padding(
      utcMonth
    )}-${utcYear} ${utcHours}:${padding(utcMinutes)}:${padding(utcSeconds)}`;
    return "";
  }

  function handleForceGMT() {
    forceGMT = !forceGMT;
    if (forceGMT) {
      forceLMT = false;
      tzOffset = 0;
      tzName = "GMT";
      makeUTC(date, time, 0);
    } else {
      makeUTC(date, time, tzOffset);
    }
  }

  function handleForceLMT() {
    forceLMT = !forceLMT;
    if (forceLMT) {
      forceGMT = false;
      tzName = "WPT";
      // calcultate local mean time offset
      // offsett
      const LMTOffset = (longitude / 15) * 3600;
      tzOffset = LMTOffset;
      makeUTC(date, time, LMTOffset);
    } else {
      makeUTC(date, time, tzOffset);
    }
  }

  async function handleContinu() {
    // prepare variables for new page
    let storedDate = date.replace(/^(\d{4})-(\d{2})-(\d{2})$/, "$3-$2-$1");
    // store data in global state
    birthData.update((placeholder) => {
      return {
        ...placeholder,
        name: name,
        date: storedDate,
        time: time,
        location: location,
        latitude: latitude,
        longitude: longitude,
        tzName: tzName,
        tzOffset: tzOffset,
        utcDateStr: utcDateStr,
        utcTime: utcTime,
      };
    });

    // test with setting the formdata. This could break how the form works.
    // id will be empty if not a saved chart

    //console.log($formData.id);

    formData.update(() => ({
      id: $formData.id,
      name: name,
      date: date,
      time: time,
      location: location,
      isSet: true,
      isInitiated: false,
      reset: false,
    }));

    // Navigate to new page with updated variables
    navigate("/calculate"); // was /horoscope
  }

  $: forceGMTDisabled = forceLMT;
  $: forceLMTDisabled = forceGMT;

  async function formDataUpdate() {
    // update the current displayed data by id
    // Split the date string, make sure none is empty
    let dateParts = date ? date.split("-") : ["00", "00", "00"];
    let year = dateParts[0] ? parseInt(dateParts[0]) : 0;
    let month = dateParts[1] ? parseInt(dateParts[1]) : 0;
    let day = dateParts[2] ? parseInt(dateParts[2]) : 0;

    // Split the time string, make sure none is empty
    let timeParts = time ? time.split(":") : ["00", "00", "00"];
    let hours = timeParts[0] ? parseInt(timeParts[0]) : 0;
    let minutes = timeParts[1] ? parseInt(timeParts[1]) : 0;
    let seconds = timeParts[2] ? parseInt(timeParts[2]) : 0;

    let token = $user.token;
    let id = $formData.id;

    // Define the URL for your API
    let storeApiUrl = "https://astro.astrosofica.nl/php/userdataupdate.php";

    // Define the data you want to send
    let data = {
      id: id,
      name: name,
      place: location,
      day: day,
      month: month,
      year: year,
      hour: hours,
      minute: minutes,
      second: seconds,
      token: token,
    };

    // Send a POST request to your API
    let response = await fetch(storeApiUrl, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(data),
    });

    if (response.statusText === "OK") {
      // The request was successful
      console.log("Data updated successfully");
      // We need to load the list modal..
      openList();
    } else if (response.error) {
      // The API returned an error
      console.log("API Error:", response.error);
      // need some proper errorhandling.. :-(
    }
  }

  async function formDataStore() {
    // function to gather information from form and send it to API for storage in database

    // Split the date string, make sure none is empty
    let dateParts = date ? date.split("-") : ["00", "00", "00"];
    let year = dateParts[0] ? parseInt(dateParts[0]) : 0;
    let month = dateParts[1] ? parseInt(dateParts[1]) : 0;
    let day = dateParts[2] ? parseInt(dateParts[2]) : 0;

    // Split the time string, make sure none is empty
    let timeParts = time ? time.split(":") : ["00", "00", "00"];
    let hours = timeParts[0] ? parseInt(timeParts[0]) : 0;
    let minutes = timeParts[1] ? parseInt(timeParts[1]) : 0;
    let seconds = timeParts[2] ? parseInt(timeParts[2]) : 0;

    let token = $user.token;

    // Define the URL for your API
    let storeApiUrl = "https://astro.astrosofica.nl/php/userdatastore.php";

    // Define the data you want to send
    let data = {
      name: name,
      place: location,
      day: day,
      month: month,
      year: year,
      hour: hours,
      minute: minutes,
      second: seconds,
      token: token,
    };

    // Send a POST request to your API
    let response = await fetch(storeApiUrl, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(data),
    });

    if (response.statusText === "OK") {
      // The request was successful
      console.log("Data stored successfully");
      // We need to load the list modal..
      openList();
    } else if (response.error) {
      // The API returned an error
      console.log("API Error:", response.error);
      // need some proper errorhandling.. :-(
    }
  }
</script>

{#if showList}
  <List show={showList} on:close={closeList} />
{/if}
<main>
  <section class="input-section">
    <div class="container">
      <!-- start form -->
      <form on:submit={handleSubmit}>
        <label class="tooltip">
          <span class="label">Naam:</span>
          <input
            type="text"
            id="name"
            bind:value={name}
            use:focus={nameInput}
            placeholder="hier naam invullen"
          />
          <a href="#top" class="tooltip" tip="Naam van persoon of gebeurtenis.">
            <img src="vraagteken.png" alt="tip" width="20px" height="20px" />
          </a></label
        >
        <label class="tooltip">
          <span class="label">Datum:</span>
          <input type="date" bind:value={date} />
          <a
            href="#top"
            class="tooltip"
            tip="Datum van geboorte of gebeurtenis: dd-mm-jjjj"
          >
            <img src="vraagteken.png" alt="tip" width="20px" height="20px" />
          </a></label
        >
        <label class="tooltip">
          <span class="label">Tijd:</span>
          <input type="Time" bind:value={time} step="1" />
          <a
            href="#top"
            class="tooltip"
            tip="Tijd van geboorte of gebeurtenis: uu:mm:ss"
          >
            <img src="vraagteken.png" alt="tip" width="20px" height="20px" />
          </a></label
        >
        <label class="tooltip">
          <span class="label">Plaats:</span>
          <input
            type="text"
            id="location"
            bind:value={location}
            placeholder="hier plaats invullen"
          />
          <a
            href="#top"
            class="tooltip"
            tip="Plaats van geboorte of gebeurtenis."
          >
            <img src="vraagteken.png" alt="tip" width="20px" height="20px" />
          </a></label
        >
        <!-- error div -->
        {#if errorMessage}
          <div class="error" transition:fade>
            {errorMessage}
          </div>
        {/if}
        <button type="submit">Zoek coördinaten en tijdzone</button>
      </form>
      <!-- end form -->
    </div>
  </section>
  {#if $showResultSection}
    <section class="result-section">
      <div class="container">
        <strong
          >Controleer de gegevens en wanneer in orde klik dan op "Ga verder
          naar.."</strong
        >
        <p class="smaller">
          <span class="label">Naam: </span><span class="smallest">{name}</span>
        </p>
        <p class="smaller">
          <span class="label">Datum: </span><span class="smallest"
            >{date.replace(/^(\d{4})-(\d{2})-(\d{2})$/, "$3-$2-$1")}
            {time}
            {tzName}
            <!--{toHour(tzOffset)}--></span
          >
        </p>
        <p class="smaller">
          <span class="label">GMT: </span><span class="smallest"
            >{utcFormatted}{makeUTC(date, time, tzOffset)}</span
          >
        </p>
        <p class="smaller"><span class="label">Plaats: </span>{location}</p>
        <p class="smaller">
          <span class="label">Coordinaten: </span>
          <span class="smallest">
            {readableLatitude(latitude)}
            {readableLongitude(longitude)}
          </span>
        </p>
        <div id="correction" class="tooltip correction" style="padding: 5px;">
          <span class="label">Tijdcorrectie: </span>
          <div class="check">
            <input
              type="checkbox"
              checked={forceGMT}
              disabled={disableGMT}
              on:change={handleForceGMT}
            />
            GMT
          </div>
          <div class="check">
            <input
              type="checkbox"
              checked={forceLMT}
              disabled={disableLMT}
              on:change={handleForceLMT}
            />
            WPT
          </div>
          <a
            href="#top"
            class="tooltip"
            tip="Tijdzones zijn lastig want hun grenzen veranderen door de tijd en geopolitieke gebeurtenissen. Het script zal vaak goed zitten maar in het geval dat je een foute GMT/UTC krijgt kun je GMT of WPT forceren. De kloktijd wordt dan GMT of WPT."
            ><img src="vraagteken.png" alt="tip" width="20px" height="20px" />
          </a>
        </div>
        <!--
          At this point we need to establish if user is logged in.
          If so we need to establish if the formData is set => show update button
          and if not set show store button.
        -->
        {#if $user && $user.loggedIn}
          <!-- logged in -->
          {#if dataIsSet && $formData.id > 0}
            <!-- FormData is stored -->
            <button class="spacer" on:click={formDataUpdate}
              >Sla eventueel aangepaste gegevens in deze horoscoop op</button
            >
          {:else}
            <!-- FormData is new -->
            <button class="spacer" on:click={formDataStore}
              >Deze nieuwe horoscoop opslaan</button
            >
          {/if}
        {/if}
        <button on:click={handleContinu}
          >Ga verder naar de Horoscoopberekening</button
        >
      </div>
    </section>
  {/if}
</main>

<style>
  .label {
    display: inline-block;
    min-width: 25%;
    max-width: 28%;
  }
  .check {
    display: inline-block;
    width: 20%;
  }
  #name,
  #location {
    width: 70%;
  }
  .smaller {
    margin-top: 4px;
    margin-bottom: 6px;
  }
  .smaller .label {
    display: inline-block;
    min-width: 30%;
    max-width: 50%;
  }

  .correction {
    justify-content: space-between;
  }
  .correction .label {
    display: inline-block;
    min-width: 30%;
    max-width: 50%;
  }

  button {
    margin-top: 10px;
    width: 100%;
    margin: auto;
    text-align: center;
    background-color: #bad095;
  }
  button:hover {
    background-color: #dde8ca;
    border-color: darkolivegreen;
  }
  /**/
  .tooltip {
    display: flex;
    flex-direction: row;
  }

  .tooltip a {
    position: relative;
    padding: 2px;
  }

  .tooltip a:hover::after {
    content: attr(tip);
    background-color: #424242;
    color: #fff;
    border-radius: 5px;
    padding: 8px;
    position: absolute;
    bottom: 100%;
    left: 50%;
    transform: translateX(-50%);
    white-space: pre-wrap;
    font-size: 14px;
    font-family: sans-serif;
    box-shadow: 0px 2px 8px rgba(0, 0, 0, 0.2);
  }

  #correction {
    margin-top: 10px;
    margin-bottom: 10px;
    border: 1px solid darkolivegreen;
    padding: 10px;
    border-radius: 5px;
  }

  .error {
    padding: 10px;
    margin: 10px 0;
    color: #721c24;
    background-color: #f8d7da;
    border: 1px solid #f5c6cb;
    border-radius: 4px;
    text-align: center;
  }
  .smallest {
    font-size: 16px;
  }
  .spacer {
    margin-bottom: 5px;
  }
</style>
